export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 30,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: '/',
    pro: '/'
  }
}
